export const encodeUrl = text => encodeURI(text).replace("/", "%2F");

export const decodeUrl = text => decodeURI(text).replace("%2F", "/");



// WEBPACK FOOTER //
// ./src/utils/urlHelper.js